module.exports = __webpack_public_path__ + "static/media/au-vi.100dd8a2.svg";